module.exports = __webpack_public_path__ + "img/oyak-insaat.cc367c68.jpg";